import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const MfeRetracementLine = observer(
  ({
    tradePlanId,
    isInRetrace,
    maxMfe,
    activateMfePositionPrice,
    retraceMfePositionPrice,
    size,
    scaleY,
    portalRef,
  }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const retracePct = tradePlan?.exitTactics['MFE_RETRACEMENT']?.retracePct ?? null;
    const mfeType = tradePlan?.exitTactics['MFE_RETRACEMENT']?.mfeType ?? null;
    const paused = tradePlan?.exitTactics['MFE_RETRACEMENT']?.paused ?? null;

    const json = {
      Category: 'Exit Tactic',
      Type: 'MFE Retracement',
      'Retrace Pct': `${Number(retracePct) * 100}%`,
      'Current Max': `${ApplyRounding(Number(maxMfe), 2)}${mfeType === 'byPnl' ? '(Pnl)' : ''}`
    };

    return (
      <>
        {scaleY ? (
          <>
            {paused ? (
              <line
                strokeDasharray={4}
                stroke={isInRetrace ? colors.red : colors.orange}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={
                  isInRetrace
                    ? scaleY(Number(retraceMfePositionPrice))
                    : scaleY(Number(activateMfePositionPrice))
                }
                y2={
                  isInRetrace
                    ? scaleY(Number(retraceMfePositionPrice))
                    : scaleY(Number(activateMfePositionPrice))
                }
              />
            ) : (
              <line
                stroke={isInRetrace ? colors.red : colors.orange}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={
                  isInRetrace
                    ? scaleY(Number(retraceMfePositionPrice))
                    : scaleY(Number(activateMfePositionPrice))
                }
                y2={
                  isInRetrace
                    ? scaleY(Number(retraceMfePositionPrice))
                    : scaleY(Number(activateMfePositionPrice))
                }
              />
            )}
            <HoverBox
              json={json}
              topBoundary={
                isInRetrace
                  ? scaleY(Number(retraceMfePositionPrice)) - 2
                  : scaleY(Number(activateMfePositionPrice)) - 2
              }
              bottomBoundary={
                isInRetrace
                  ? scaleY(Number(retraceMfePositionPrice)) + 2
                  : scaleY(Number(activateMfePositionPrice)) + 2
              }
              leftBoundary={0}
              rightBoundary={size}
              portalRef={portalRef}
              size={size}
            />
          </>
        ) : null}
      </>
    );
  }
);
